// Colors
export const colors = {
  primary: '#485A6B',
  secondary: '#E6DECA',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  white: '#ffffff',
  black: '#000000',
  pink: '#f5a6cf',
  green: '#5c9a33',
  gray: {
    100: '#f8f9fa',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  },
};

// Typography
export const typography = {
  fontFamily: {
    base: '"Red Hat Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    heading: '"Montserrat", sans-serif',
    body: '"Nunito", sans-serif',
  },
  fontSize: {
    small: 14,
    base: 16,
    large: 18,
    xlarge: 24,
    xxlarge: 32,
  },
  fontWeight: {
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
};

// Spacing
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// Border Radius
export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  full: 9999,
};

// Shadows
export const shadows = {
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.18,
    shadowRadius: 1.0,
    elevation: 1,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.30,
    shadowRadius: 4.65,
    elevation: 8,
  },
}; 

export const badgeStyle = (isMobile: boolean) => ({
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  padding: isMobile ? spacing.sm : spacing.md,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  fontWeight: 600,
  fontSize: isMobile ? 13 : 16,
  marginBottom: 0,
  border: '1px solid #e0e0e0',
  minWidth: isMobile ? 150 : 250,
  maxWidth: isMobile ? 220 : 250,
  boxSizing: 'border-box',
});